export function index(ids = [], page, search = '', extraFilters) {
    if (Array.isArray(ids) && ids.length) {
        ids = "filter[ids]=" + ids.join("|");
        // limit = 100;
    }

    if (search) {
        search = 'filter[name]=' + search;
    }

    return axios.get(route('api.manage.companies.channels') + `?page=${page}&${ids}&${search}&${extraFilters}`)
        .then((response) => {
            return response.data;
        });
}
